import { AutogenModelEdistatuseventTable, AutogenRowEdistatuseventTable } from "./autogen/AutogenModelEdistatuseventTable";

export class ModelEdistatuseventTable extends AutogenModelEdistatuseventTable<RowEdistatuseventTable> {
	constructor() {
		super(RowEdistatuseventTable);
	}
}

export class RowEdistatuseventTable extends AutogenRowEdistatuseventTable {
}